export const trackHeaderClicks = (group: 'logo-home' | 'myaccount-menu' | 'utility' | 'menu-mobile', value: string) => {
  window.dataLayer.push({
    event: 'header.interaction.click',
    group: group,
    value: value,
  });
};
